var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8538 16.9796C16.9002 17.026 16.9371 17.0812 16.9622 17.1419C16.9874 17.2026 17.0003 17.2676 17.0003 17.3333C17.0003 17.399 16.9874 17.4641 16.9622 17.5248C16.9371 17.5855 16.9002 17.6406 16.8538 17.6871C16.8073 17.7335 16.7522 17.7704 16.6915 17.7955C16.6308 17.8207 16.5657 17.8336 16.5 17.8336C16.4343 17.8336 16.3693 17.8207 16.3086 17.7955C16.2479 17.7704 16.1927 17.7335 16.1463 17.6871L12 13.5402L7.85378 17.6871C7.75996 17.7809 7.63272 17.8336 7.50003 17.8336C7.36735 17.8336 7.2401 17.7809 7.14628 17.6871C7.05246 17.5932 6.99976 17.466 6.99976 17.3333C6.99976 17.2006 7.05246 17.0734 7.14628 16.9796L11.2932 12.8333L7.14628 8.68707C7.05246 8.59325 6.99976 8.466 6.99976 8.33332C6.99976 8.20063 7.05246 8.07339 7.14628 7.97957C7.2401 7.88575 7.36735 7.83304 7.50003 7.83304C7.63272 7.83304 7.75996 7.88575 7.85378 7.97957L12 12.1264L16.1463 7.97957C16.2401 7.88575 16.3674 7.83304 16.5 7.83304C16.6327 7.83304 16.76 7.88575 16.8538 7.97957C16.9476 8.07339 17.0003 8.20063 17.0003 8.33332C17.0003 8.466 16.9476 8.59325 16.8538 8.68707L12.7069 12.8333L16.8538 16.9796Z",
    fill: "#01AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.00aded3799894f78a4affe6c5fb26aa9.svg";
export { ForwardRef as ReactComponent };